import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';

@Injectable()
export class GermanPaginatorIntl extends MatPaginatorIntl {
    override nextPageLabel = 'Nächste Seite';
    override previousPageLabel = 'Vorherige Seite';
    override itemsPerPageLabel = 'Einträge pro Seite:';
    override firstPageLabel = 'Erste Seite';
    override lastPageLabel = 'Letzte Seite';

    override getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0 || pageSize === 0) {
            return '0 von 0';
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
        return `${startIndex + 1} – ${endIndex} von ${length}`;
    };
}
